import { cva, type VariantProps } from 'class-variance-authority';

export const badgeVariants = cva(
  'inline-flex items-center rounded-full px-2.5 py-1 font-mono text-[9px] font-bold uppercase tracking-widest',
  {
    variants: {
      tone: {
        neutral: 'bg-zinc-100 text-muted-foreground dark:bg-zinc-800',
        amber: 'bg-amber-100 text-amber-700 dark:bg-amber-950/40 dark:text-amber-400',
        sky: 'bg-sky-100 text-sky-700 dark:bg-sky-950/40 dark:text-sky-400',
        violet: 'bg-violet-100 text-violet-700 dark:bg-violet-950/40 dark:text-violet-400',
        emerald: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-400',
        red: 'bg-red-100 text-red-700 dark:bg-red-950/40 dark:text-red-400',
      },
    },
    defaultVariants: { tone: 'neutral' },
  },
);

export type BadgeTone = NonNullable<VariantProps<typeof badgeVariants>['tone']>;
